export default __webpack_public_path__ + "static/media/قراءات في الاعمال الكاملة.8dd79ba4.pdf";